<div class="app-view" data-testid="app-view"
  [class.app-view--hidden]="isRouting()">
  <div class="app-container">
    <router-outlet></router-outlet>
  </div>
  <ccdl-footer [platform]="Platform_Name_Enum.CUI"></ccdl-footer>
</div>